import * as types from './actionTypes'
import * as api from '../../../../common/api'

export const fetchSoftwareProductsList = id => ({
    types: [types.FETCH_SOFTWARE_PRODUCTS_REQUEST, types.FETCH_SOFTWARE_PRODUCTS_SUCCESS, types.FETCH_SOFTWARE_PRODUCTS_FAILURE],
    apiCall: () => api.getSoftwareProducts(id)
});